<template>
    <div class="enterprise-item" @click="toDetail(data)">
        <img :src="data.image" alt="" />
        <el-tooltip effect="light" :content="data.title" placement="bottom">
            <p class="line-one-ellipsis">{{ data.title }}</p>
        </el-tooltip>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        data: Object,
    },
    methods: {
        toDetail(e) {
            if (e.url !== '') {
                window.open(e.url, "_blank");
            } else {
                this.$router.push({
                    path: "/news/17/detail",
                    query: { id: e.id, categoryId: e.category_id },
                });
            }
        },
    },
};
</script>

<style scoped>
.enterprise-item {
    color: #121126;
    font-size: 13px;
    width: 190px;
    margin-bottom: 22px;
    margin-right: 29px;
}
.enterprise-item:nth-child(3n) {
    margin-right: 0;
}

img {
    width: 100%;
    height: 128px;
    border-radius: 6px;
}
p {
    margin-top: 8px;
}
</style>
